module.exports = __webpack_public_path__ + "static/media/tron-concept-01.e850c440.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tron-concept-01.jpg
// module id = 652
// module chunks = 0